define(function (require) {
    "use strict";

    var Logger = require("logger");

    return function (message, url, line, col, ex) {
        var logger = Logger.getLogger("ErrorHandler");
        var errorMsg = "Javascript Runtime Exception Error\nMessage: " + message + "\nURL: " + url + "\nLine: " + line;

        if (col) {
            errorMsg += "\nColumn: " + col;
        }
        if (ex && ex.message) {
            errorMsg += "\n\nException: " + ex.message;
        }
        if (ex && ex.stack) {
            errorMsg += "\n\nStacktrace: " + ex.stack;
        }

        logger.error(errorMsg);

        // Fail silently and if possible gracefully only in production
        // For development we will also alert this issue so people will not
        // be able to ignore it


        // Just fail silently or gracefully if possible
        return true;
    };
});
